export { AnchoredLayerBoundariesElement as TooltipBoundariesElement, AnchoredLayerPosition as TooltipPosition } from '@doordash/component-layer-manager';

var TooltipInteractionType;

(function (TooltipInteractionType) {
  TooltipInteractionType["Hover"] = "HOVER";
  TooltipInteractionType["Focus"] = "FOCUS";
  TooltipInteractionType["Click"] = "CLICK";
  TooltipInteractionType["ToggleHover"] = "TOGGLE_HOVER";
  TooltipInteractionType["ToggleFocus"] = "TOGGLE_FOCUS";
  TooltipInteractionType["ToggleClick"] = "TOGGLE_CLICK";
  TooltipInteractionType["Controlled"] = "CONTROLLED";
})(TooltipInteractionType || (TooltipInteractionType = {}));

var TooltipContentWrapperDisplayMode;

(function (TooltipContentWrapperDisplayMode) {
  TooltipContentWrapperDisplayMode["Flex"] = "flex";
  TooltipContentWrapperDisplayMode["InlineFlex"] = "inline-flex";
  TooltipContentWrapperDisplayMode["InlineBlock"] = "inline-block";
  TooltipContentWrapperDisplayMode["Block"] = "block";
  TooltipContentWrapperDisplayMode["Inline"] = "inline";
})(TooltipContentWrapperDisplayMode || (TooltipContentWrapperDisplayMode = {}));

var TooltipType;

(function (TooltipType) {
  TooltipType["Informational"] = "Informational";
  TooltipType["Highlight"] = "Highlight";
})(TooltipType || (TooltipType = {}));

export { TooltipContentWrapperDisplayMode, TooltipInteractionType, TooltipType };
